<div class="container p-5">
    <div class="card">
    <h3>Customer Login</h3>

    <div class="row p-t-5 mt-5 mb-5">
        <div class="col-6">
            <h5>Current Customers</h5>
            <div *ngIf="customer==null">
                <form id="login" [formGroup]="loginForm" (submit)="login()">


                    <div class="form-group">
                        <label i18n>Email</label>
                        <input type="email"
                               id="login_email"
                               name="user_email"
                               class="form-control"
                               formControlName="login_email"
                               autocomplete="off"
                               required=""

                        >
                        <div class="invalid-feedback">
                            <div i18n>Email is required</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label i18n>Password</label>
                        <input type="password"
                               id="login_password"
                               name="login_password"
                               class="form-control"
                               formControlName="login_password"
                               autocomplete="off"
                               required=""

                        >
                        <div class="invalid-feedback">
                            <div i18n>Email is required</div>
                        </div>
                    </div>

                    <div style="    margin-top: 12px;">
                        <div class="pull-left">
                            <a [routerLink]="'/user/password/reset'" i18n>Forgot password</a>
                        </div>
                        <div class="text-right mt-2 pull-right">


                        </div>
                    </div>
                    <br>
                    <div>
                        <button id="save_new_user_btn" class="btn btn-success btn-block mt-4"
                                type="submit"
                                i18n>
                            <span   *ngIf="!isLoggin" >Login</span>
                            <span *ngIf="isLoggin"><img src="assets/loader.gif" width="20"/> Please wait ...</span>

                        </button>
                    </div>

                </form>

            </div>

        </div>
        <div class="col-6">
            <h5 i18n>New Customers</h5>
            <div class="form-group" i18n>
            Create your account now and enjoy the full features of AlArabiya site.
            </div>
            <div class="text-left">
                <input class="btn btn-secondary mt-3" [routerLink]="'/user/signup'" value="Create new account"/>
            </div>
        </div>
    </div>
    </div>
</div>


<!--<p class="text-center"> please fill in the following fields to login your account.</p>-->
<!--<mat-card class="my-card text-center">-->
<!--    <form class="my-form container " [formGroup]="profileForm" (ngSubmit)="profileForm.valid && onSubmit()"  >-->
<!--        <mat-card-content class="text-center" >-->


<!--            <mat-form-field class="full-width">-->
<!--                <mat-label>Email</mat-label>-->
<!--                <input type="email"  required matInput value=" " formControlName="email"   name="email">-->
<!--                <mat-error  *ngIf="profileForm.controls['email'].invalid">{{getEmailErrorMessage()}}</mat-error>-->
<!--            </mat-form-field>-->
<!--            <mat-form-field class="full-width">-->
<!--                <mat-label>Password</mat-label>-->
<!--                <input type="password"  matInput value=" " formControlName="password"    name="password" required>-->
<!--                <mat-error  *ngIf="profileForm.controls['password'].invalid">{{getPasswordErrorMessage()}}</mat-error>-->
<!--            </mat-form-field>-->


<!--        </mat-card-content>-->
<!--        <mat-card-actions>-->
<!--            <button mat-raised-button  style="background-color: grey;padding: 3px 60px;">Cancel</button>-->
<!--            <button  type="submit" [disabled]="!profileForm.valid" mat-raised-button  style="background-color: #17929e;padding: 3px 60px; ">Login</button>-->
<!--        </mat-card-actions>-->
<!--    </form>-->

<!--</mat-card>-->
